<template>
  <div>
    <sui-popup
      content="This candidate has been registered, but still not be available to be recommended. Please update the candidate’s information."
      size="mini"
    >
      <div slot="trigger" class="job-sticker">Registered</div>
    </sui-popup>
  </div>
</template>
<script>
export default {};
</script>
<style scoped lang="scss">
@import "~@/assets/stylesheets/application";
@import "~@/assets/stylesheets/register";
.job-sticker {
  display: inline-flex;
  font-family: "Poppins", sans-serif !important;
  font-weight: 700;
  font-size: 12px;
  font-weight: 700;
  border-radius: 100rem;
  background: #139EFF;
  padding: 2px 8px;
  color: $white;
  cursor: pointer;
  white-space: nowrap;
}

@media only screen and (max-width: 991px) {
  .job-sticker {
    font-size: 10px;
  }
}
</style>
